import React from 'react';
import {
	Table,
	TableHead,
	TableHeadRow,
	TableHeadCell,
	TableBody,
	TableRow,
	TableCell,
} from './table';
import { kampioenen } from '../lib/historicalData';

export default function KampioenenTable() {
	return (
		<div className="overflow-x-auto">
			<Table className="table-auto overflow-scroll w-full">
				<TableHead>
					<TableHeadRow>
						<TableHeadCell>Seizon</TableHeadCell>
						<TableHeadCell>Divisie</TableHeadCell>
						<TableHeadCell>Kampioen</TableHeadCell>
					</TableHeadRow>
				</TableHead>
				<TableBody className="bg-white divide-y divide-gray-200">
					{kampioenen.map((seizoen, i) => (
						<TableRow key={i} striped>
							<TableCell>{seizoen.Seizoen}</TableCell>
							<TableCell>{seizoen.Divisie}</TableCell>
							<TableCell>{seizoen.Kampioen}</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</div>
	);
}
